export type PrintQrItem = {
  qrUrl: string;
  locationLabel: string;
};

export const generatePrintTemplate = (
  qrItems: PrintQrItem[],
  collapsedLogoSrc: string = "",
  appLogoSrc: string = "",
  primaryColor: string = "#000",
) => {
  const fallbackItem: PrintQrItem = {
    qrUrl: "",
    locationLabel: "",
  };

  const normalizedItems = Array.from({ length: 4 }, (_, index) => qrItems[index] || qrItems[0] || fallbackItem);
  const qrValues = normalizedItems.map((item) => item.qrUrl || "");

  const renderTemplate = (templateId: number, item: PrintQrItem) => `
                <div class="template-wrapper">
                        <div class="header">
                                <div class="logo-container">
                                     <!-- ${
                                       collapsedLogoSrc
                                         ? `<img src="${collapsedLogoSrc}" alt="KSI Logo" class="collapsed-logo" />`
                                         : ""
                                     } -->
                                        <img src="${appLogoSrc}" alt="KSI Integrated Facility Services" class="app-logo" />
                                </div>
                                <div class="title">TIME & ATTENDANCE</div>
                                <div class="location-title">${item.locationLabel || ""}</div>
                        </div>

                        <div class="content">
                                <div class="qr-wrapper">
                                        <div class="qr-code" id="qrcode${templateId}">
                                                <!-- QR Code will be generated here -->
                                        </div>
                                </div>
                        </div>

                        <div class="footer">
                                <div class="footer-text">
                                        For any questions, concerns, or feedback,<br>please contact <a href="mailto:info@ksiintegrated.com">info@ksiintegrated.com</a>
                                </div>
                        </div>
                </div>
    `;

  return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>${normalizedItems[0].locationLabel || "QR Code"} - QR Code</title>
    <style>
        @page {
            size: A4;
            margin: 0;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: Arial, sans-serif;
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            padding: 0;
        }

        .page-container {
            width: 210mm;
            height: 297mm;
            background: white;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;
            padding: 4mm;
            gap: 4mm;
        }

        .template-wrapper {
            display: flex;
            flex-direction: column;
            padding: 8mm 10mm;
            border: 0.5pt solid #e0e0e0;
            page-break-inside: avoid;
            overflow: hidden;
        }

        .header {
            margin-bottom: 2mm;
            flex-shrink: 0;
        }

        .logo-container {
            margin-bottom: 3mm;
            display: flex;
            align-items: center;
            gap: 2px;
            min-height: 8mm;
        }

        .collapsed-logo {
            width: 8mm;
            height: 8mm;
            object-fit: contain;
            flex-shrink: 0;
        }

        .app-logo {
            height: 7mm;
            object-fit: contain;
            flex-shrink: 0;
        }

        .divider {
            width: 100%;
            height: 0.5pt;
            background: #000;
            margin: 2.5mm 0;
        }

        .title {
            font-size: 20px;
            font-weight: 700;
            text-align: center;
            margin: 20mm 0 0 0;
            color: ${primaryColor};
            font-family: 'Avenir Next LT Pro', 'Avenir Next', 'Avenir', sans-serif;
            text-transform: uppercase;
            text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.15);
            line-height: 1.1;
            flex-shrink: 0;
        }

        .location-title {
            margin-top: 2.5mm;
            text-align: center;
            font-size: 12px;
            font-weight: 600;
            color: #000;
            line-height: 1.2;
            min-height: 14px;
        }

        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 30mm;
        }

        .qr-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 4mm 0;
            flex-shrink: 0;
        }

        .qr-code {
            width: 45mm;
            height: 45mm;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        .qr-code canvas {
            max-width: 100%;
            max-height: 100%;
        }

        .footer {
            text-align: center;
            padding-top: 3mm;
            margin-top: auto;
            flex-shrink: 0;
        }

        .footer-text {
            font-size: 7px;
            color: #000;
            line-height: 1.3;
        }

        .footer-text a {
            color: #000;
            text-decoration: none;
        }

        .footer-text a:hover {
            text-decoration: underline;
        }

        @media print {
            body {
                background: white;
                padding: 0;
                margin: 0;
            }

            .page-container {
                box-shadow: none;
                page-break-inside: avoid;
                width: 210mm;
                height: 297mm;
            }

            .template-wrapper {
                border: none;
            }

            .title {
                color: ${primaryColor} !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                color-adjust: exact;
            }

            @page {
                margin: 0;
            }
        }
    </style>
</head>
<body>
    <div class="page-container">
        ${normalizedItems.map((item, index) => renderTemplate(index + 1, item)).join("")}
    </div>

    <script src="https://cdnjs.cloudflare.com/ajax/libs/qrious/4.0.2/qrious.min.js"></script>
    <script>
        window.onload = function() {
            const qrValues = ${JSON.stringify(qrValues)};
            for (let i = 1; i <= 4; i++) {
                const canvas = document.createElement('canvas');
                const qr = new QRious({
                    element: canvas,
                    value: qrValues[i - 1] || '',
                    size: 300,
                    background: 'white',
                    foreground: 'black',
                    level: 'M'
                });
                
                document.getElementById('qrcode' + i).appendChild(canvas);
            }
            
            // Auto print after loading (optional - remove if not needed)
            setTimeout(() => {
                window.print();
                // window.close(); // Uncomment if you want to auto-close
            }, 500);
        };
    </script>
</body>
</html>`;
};

// If you're using React and want to integrate your Logo component:
export const generatePrintTemplateWithReactLogo = (qrUrl: string, collapsedLogoSrc: string, logoHtml: string) => {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>SDS Information QR Code</title>
    <style>
        @page {
            size: A4;
            margin: 0;
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: Arial, sans-serif;
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            padding: 0;
        }

        .page-container {
            width: 210mm;
            height: 297mm;
            background: white;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr 1fr;
            padding: 4mm;
            gap: 4mm;
        }

        .template-wrapper {
            display: flex;
            flex-direction: column;
            padding: 8mm 10mm;
            border: 0.5pt solid #e0e0e0;
            page-break-inside: avoid;
            overflow: hidden;
        }

        .header {
            margin-bottom: 2mm;
            flex-shrink: 0;
        }

        .logo-container {
            margin-bottom: 3mm;
            display: flex;
            align-items: center;
            gap: 6mm;
            min-height: 8mm;
        }

        .collapsed-logo {
            width: 8mm;
            height: 8mm;
            object-fit: contain;
            flex-shrink: 0;
        }

        .divider {
            width: 100%;
            height: 0.5pt;
            background: #000;
            margin: 2.5mm 0;
        }

        .title {
            font-size: 16px;
            font-weight: bold;
            color: #000;
            text-align: center;
            letter-spacing: 0.5px;
            margin: 0;
            margin-top: 10mm;
            line-height: 1.1;
            flex-shrink: 0;
        }

        .content {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 30mm;
        }

        .qr-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 4mm 0;
            flex-shrink: 0;
        }

        .qr-code {
            width: 45mm;
            height: 45mm;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        .qr-code canvas {
            max-width: 100%;
            max-height: 100%;
        }

        .footer {
            text-align: center;
            padding-top: 3mm;
            margin-top: auto;
            flex-shrink: 0;
        }

        .footer-text {
            font-size: 7px;
            color: #000;
            line-height: 1.3;
        }

        .footer-text a {
            color: #000;
            text-decoration: none;
        }

        .footer-text a:hover {
            text-decoration: underline;
        }

        @media print {
            body {
                background: white;
                padding: 0;
                margin: 0;
            }

            .page-container {
                box-shadow: none;
                page-break-inside: avoid;
                width: 210mm;
                height: 297mm;
            }

            .template-wrapper {
                border: none;
            }

            @page {
                margin: 0;
            }
        }
    </style>
</head>
<body>
    <div class="page-container">
        <!-- Template 1 -->
        <div class="template-wrapper">
            <div class="header">
                <div class="logo-container">
                    <img src="${collapsedLogoSrc}" alt="KSI Logo" class="collapsed-logo" />
                    ${logoHtml}
                </div>
                
                <div class="divider"></div>
                
                <div class="title">TIME & ATTENDANCE</div>
            </div>

            <div class="content">
                <div class="qr-wrapper">
                    <div class="qr-code" id="qrcode1">
                        <!-- QR Code will be generated here -->
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="footer-text">
                    For any questions, concerns, or feedback,<br>please contact <a href="mailto:info@ksiintegrated.com">info@ksiintegrated.com</a>
                </div>
            </div>
        </div>

        <!-- Template 2 -->
        <div class="template-wrapper">
            <div class="header">
                <div class="logo-container">
                    <img src="${collapsedLogoSrc}" alt="KSI Logo" class="collapsed-logo" />
                    ${logoHtml}
                </div>
                
                <div class="divider"></div>
                
                <div class="title">TIME & ATTENDANCE</div>
            </div>

            <div class="content">
                <div class="qr-wrapper">
                    <div class="qr-code" id="qrcode2">
                        <!-- QR Code will be generated here -->
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="footer-text">
                    For any questions, concerns, or feedback,<br>please contact <a href="mailto:info@ksiintegrated.com">info@ksiintegrated.com</a>
                </div>
            </div>
        </div>

        <!-- Template 3 -->
        <div class="template-wrapper">
            <div class="header">
                <div class="logo-container">
                    <img src="${collapsedLogoSrc}" alt="KSI Logo" class="collapsed-logo" />
                    ${logoHtml}
                </div>
                
                <div class="divider"></div>
                
                <div class="title">TIME & ATTENDANCE</div>
            </div>

            <div class="content">
                <div class="qr-wrapper">
                    <div class="qr-code" id="qrcode3">
                        <!-- QR Code will be generated here -->
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="footer-text">
                    For any questions, concerns, or feedback,<br>please contact <a href="mailto:info@ksiintegrated.com">info@ksiintegrated.com</a>
                </div>
            </div>
        </div>

        <!-- Template 4 -->
        <div class="template-wrapper">
            <div class="header">
                <div class="logo-container">
                    <img src="${collapsedLogoSrc}" alt="KSI Logo" class="collapsed-logo" />
                    ${logoHtml}
                </div>
                
                <div class="divider"></div>
                
                <div class="title">TIME & ATTENDANCE</div>
            </div>

            <div class="content">
                <div class="qr-wrapper">
                    <div class="qr-code" id="qrcode4">
                        <!-- QR Code will be generated here -->
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="footer-text">
                    For any questions, concerns, or feedback,<br>please contact <a href="mailto:info@ksiintegrated.com">info@ksiintegrated.com</a>
                </div>
            </div>
        </div>
    </div>

    <script src="https://cdnjs.cloudflare.com/ajax/libs/qrious/4.0.2/qrious.min.js"></script>
    <script>
        window.onload = function() {
            for (let i = 1; i <= 4; i++) {
                const canvas = document.createElement('canvas');
                const qr = new QRious({
                    element: canvas,
                    value: '${qrUrl}',
                    size: 300,
                    background: 'white',
                    foreground: 'black',
                    level: 'M'
                });
                
                document.getElementById('qrcode' + i).appendChild(canvas);
            }
            
            // Auto print after loading (optional - remove if not needed)
            setTimeout(() => {
                window.print();
                // window.close(); // Uncomment if you want to auto-close
            }, 500);
        };
    </script>
</body>
</html>`;
};
